import Vue from 'vue'
import axioss from 'axios';
import qs from 'qs'
import router from '../router/router'

const axios = axioss.create({
// 请求超时时间
    timeout: 400000 ,
    withCredentials: true
})
axios.defaults.crossDomain = true;
axios.defaults.withCredentials= true;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
Vue.prototype.$axios=axios;

if(process.env.VUE_APP_URL){
    axios.defaults.baseURL =process.env.VUE_APP_URL;
}

//测试
// axios.defaults.baseURL ="//admin-api.uniquecncmach.com/";
//188
// axios.defaults.baseURL ="//xb.admin.com/";
//在家办公
// axios.defaults.baseURL ="//admin-api.oemserviceses.com/";

// axios.defaults.baseURL ="//admin-api.us.uniquecncmach.com/";

//正式站
 //axios.defaults.baseURL ="//manage-admin.chukouplus.com"
//演示站
axios.defaults.baseURL ="//manage-admin.show.chukouplus.com"

Vue.config.productionTip = false


axios.interceptors.request.use(function (config) {
    config.headers.Authorization = window.sessionStorage.getItem('signature');
    if(config.method=="post"){
        config.data=qs.stringify(config.data)
    }
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
    if (response) {
        // 不同状态码下的统一操作
        let msg=response.data.msg
        switch (parseInt(response.data.code)) {
            case 400:
                // Vue.prototype.$message.error(msg, [1000])
                break;
            case 401:
                setTimeout(() => {
                    router.push('/login')
                }, 800)

                Vue.prototype.$message.error(msg,1.5)
                break;
            case 403:
                Vue.prototype.$message.error(msg,1.5)
                break;
            case 404:
                Vue.prototype.$message.error(msg,1.5)
                break;
            case 200:
                // Vue.prototype.$message.success(msg,1.5)
                break;
            case 500:
                msg=="参数不能为空"?msg="请选择数据":msg
                Vue.prototype.$message.destroy()
                Vue.prototype.$message.error(msg,1.5 )
                break;
        }
    } else {

        if (!window.navigator.onLine) {
            // 断网处理
        }
    }
    return response
}, function (error) {
    // console.log(error)
    // 对响应错误做点什么
    return "notime";
});

export default axios;
